import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDashboardContext } from "../../../Context/DashboardContext.jsx";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const SectionLink = ({ icon: Icon, title, link }) => {
  const { actualSection, setActualSection } = useDashboardContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [actual, setActual] = useState(false);

  const diccRoutes = {
    "/users": "Usuarios",
    "/especials": "Especiales",
    "/products": "Productos",
    "/": "Dashboard",
    "/help": "Ayuda",
    "/settings": "Ajustes",
    "/top-sellers": "Mas vendidos",
  };

  const handleClick = () => {
    navigate("/dashboard" + link);
  };

  useEffect(() => {
    const last = "/" + location.pathname.split("/").pop();
    if (diccRoutes[last] === title) {
      setActual(true);
    } else setActual(false);
  }, [location.pathname]);

  return (
    <div
      className={`w-full flex text-[16px] gap-x-2 cursor-pointer hover:bg-pink-100 p-2 items-center group rounded-md ${actual ? "bg-pink-100" : ""}`}
      onClick={handleClick}
    >
      <Icon
        className={`group-hover:text-pink-600 transition-all ${actual ? "text-pink-600" : "text-pink-500 "}`}
      />
      <div
        className={` font-semibold group-hover:text-pink-600 transition-all ${actual ? "text-pink-600" : "text-slate-500"}`}
      >
        {title}
      </div>
    </div>
  );
};
export default SectionLink;
